import { podcastsService } from "../../api/podcasts";

export const GET_DATA = "GET_PODCASTS";
export const ADD = "ADD_PODCASTS";
export const UPDATE = "UPDATE_PODCASTS";
export const DELETE = "DELETE_PODCASTS";
export const SET_INITIALIZED_DATA = "SET_INITIALIZED_DATA_PODCASTS";
export const ADD_SELECTED_ROW = "ADD_SELECTED_ROW_PODCASTS";
export const DELETE_SELECTED_ROW = "DELETE_SELECTED_ROW_PODCASTS";
export const SET_SELECTED_ROWS = "SET_SELECTED_ROWS_PODCASTS";
export const SET_FILTERS = "SET_FILTERS_PODCASTS";
export const SET_SORTERS = "SET_SORTERS_PODCASTS";

export function getData(filters = {}, sorters = {}, page = 1) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const limit = getState().podcastsReducer.limit || 25;
      podcastsService.getData(filters, sorters, page, limit).then(
        (response) => {
          dispatch({ type: GET_DATA, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function get(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      podcastsService.get(id).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function add(form) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      podcastsService.add(form).then(
        (response) => {
          dispatch({ type: ADD, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function update(id, form) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      podcastsService.update(id, form).then(
        (response) => {
          dispatch({ type: UPDATE, id, payload: response });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      podcastsService.delete(id).then(
        (response) => {
          dispatch({ type: DELETE, id });
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  };
}

export function setInitializedData(value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_INITIALIZED_DATA, payload: value });
      resolve();
    });
  };
}

export function addSelectedRow(record, isSearcher = false) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: ADD_SELECTED_ROW, payload: record, isSearcher });
      resolve();
    });
  };
}

export function removeSelectedRow(id, isSearcher = false) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: DELETE_SELECTED_ROW, id, isSearcher });
      resolve();
    });
  };
}

export function setSelectedRows(records, isSearcher = false) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_SELECTED_ROWS, payload: records, isSearcher });
      resolve();
    });
  };
}

export function setFilters(value, isSearcher = false) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_FILTERS, payload: value, isSearcher });
      resolve();
    });
  };
}

export function setSorters(value, isSearcher = false) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: SET_SORTERS, payload: value, isSearcher });
      resolve();
    });
  };
}


